module.exports = __webpack_public_path__ + "static/media/6-iveco.407b2404.jpg";